module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large",
    staticStyle: {
      "width": "1200px"
    }
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.title) + "\n      "), _c('a', {
    staticClass: "button is-success is-pulled-right",
    on: {
      "click": _vm.newComment
    }
  }, [_vm._v("\n        New Comment\n      ")])])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.comments.length > 0) ? _vm._l((_vm.comments), function(comment) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(comment.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(comment.user.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.parseDepartment(comment.department)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(comment.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(comment.created_at))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [(parseInt(comment.attachments) === 1) ? _c('tooltip', {
      attrs: {
        "label": "Files",
        "type": "default",
        "placement": "left"
      }
    }, [_c('a', {
      staticClass: "button button-table is-small",
      on: {
        "click": function($event) {
          return _vm.attachments()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-files-o"
    })])]) : _vm._e()], 1)])
  }) : [_vm._m(1)]], 2)])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    class: {
      'button': true,
      'is-primary': true,
      'is-disabled': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Close")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("User")]), _vm._v(" "), _c('th', [_vm._v("Departament")]), _vm._v(" "), _c('th', [_vm._v("Resume")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Files")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No comments")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-392f22f1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/customer/Comments.vue
// module id = 1110
// module chunks = 39